import React, { useState, useEffect, useCallback } from "react";
import { instance } from "../../axios";
import {
  PageHeader,
  UiInput,
  UiButton,
  UiToggle,
  UiRadio,
  UiActioButton,
  TableZero,
  PageError,
  UiSelect,
  OverlayLoader,
  UiPopover,
  BgLoader,
} from "../../ui";
import DataTable from 'react-data-table-component';

import { useForm, Controller, useFieldArray } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { toast } from "react-toastify";
import { NavLink, useNavigate, useParams, useLocation, Outlet, useOutletContext } from "react-router-dom";

import NiceModal, { show, useModal } from "@ebay/nice-modal-react";
import { Helmet } from "react-helmet";
import { TbExternalLink } from "react-icons/tb";
import { VscLinkExternal } from "react-icons/vsc";
import Swal from "sweetalert2";



export function WhatsappSettings() {
  const [bg_loader, setBGLoader] = useState(false);

  const [state, setState] = useState({ count: 0 });
  const [loader, showLoader] = useState({});

  const fetchData = () => {
    setBGLoader(true)
    instance
      .get("/notification_settings?channel=whatsapp")
      .then(function (response) {
        setBGLoader(false)
        setState({ ...state, ...response.data });
      })
      .catch(function (error) { })
      .then(function () { });
  }
  useEffect(() => {
    fetchData()

    window.fbAsyncInit = function () {
      // JavaScript SDK configuration and setup
      window.FB.init({
        appId: '2244537659052417', // Facebook App ID
        cookie: true, // enable cookies
        xfbml: true, // parse social plugins on this page
        version: 'v16.0' //Graph API version
      });
    };
    (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));

  }, []);



  const wamodal = useModal('whatsapp-template');


  const templateModal = (id) => {

    wamodal.show({ id: id }).then((res) => {
      fetchData();
    });



  }

  if (state.status == 'error') {
    return (
      <PageError msg={state.msg} code={state.code} />
    )
  }



  const connectWA = (token) => {
    setBGLoader(true)
    instance
      .get("/connect_wa?token=" + token)
      .then(function (response) {
        setBGLoader(false)
        fetchData()

      })
      .catch(function (error) { })
      .then(function () { });
  }


  const disconnectWA = () => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, disconnect!'
    }).then((result) => {
      if (result.isConfirmed) {

        setBGLoader(true)
        instance
          .get("/connect_wa?remove=1")
          .then(function (response) {
            setBGLoader(false)
            fetchData()

          })
          .catch(function (error) { })
          .then(function () { });
      }
    })

  }

  const syncTemplates = () => {
    setBGLoader(true)
    instance
      .get("/sync_wa_templates")
      .then(function (response) {
        setBGLoader(false)
        if (response.data.status == "success") {
          toast(response.data.msg, { type: "success" });
          fetchData();
        }
        if (response.data.status == "error") {
          toast(response.data.msg, { type: "error" });
        }

      })
      .catch(function (error) { })
      .then(function () { });
  }


  const columns = [
    {
      name: 'Name',
      selector: row => row.name,
      sortable: true,
      cell: row => (<b>{row.name}</b>),
      width: '160px'
    },
    {
      name: 'Category',
      selector: row => row.template_category,
      sortable: true,
      cell: row => (<b>{row.template_category}</b>),
      width: '120px'
    },
    {
      name: 'Template',
      selector: row => row.template,
      cell: row => (<><span className="py-2 text-secondary">{row.template}</span></>)
    },
    {
      name: 'Status',
      selector: row => row.status,
      cell: row => (<><span className={`badge bg-secondary wa_${row.status}`}>{row.status}</span>{row.reason && row.reason != '' ? <UiPopover msg={row.reason} /> : ''}</>),
      sortable: true,
      width: '200px'
    },

    {
      name: '',
      width: (window.innerWidth > 768 ? '0px' : '130px'),
      selector: row => row.status,
      cell: row => (
        <div className="tableaction">
          <UiActioButton title="Edit" action={() => templateModal(row.id)} />
          <UiActioButton title="Delete" action={() => handleDelete(row.id)} />
        </div>
      )
    },
  ];
  const handleDelete = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setBGLoader(true)
        instance
          .get("/update_wa_template?delete=" + id)
          .then(function (response) {
            setBGLoader(false)
            if (response.data.status == 'success') {
              toast(response.data.msg, { type: "success" });
            } else {
              toast(response.data.msg, { type: "error" });
            }

            fetchData();

          })

      }
    })


  }


  const saveSetting = (task, act) => {
    var action = 1;
    if (act == 1) {
      action = 0;
    }
    showLoader({ ...loader, [task]: true });
    instance
      .get("/update_notification_settings?action=" + task + "&value=" + action)
      .then(function (response) {
        showLoader({ ...loader, [task]: false });
        if (response.data.status == 'success') {
          if (task == 'chat_bot') {
            setState({ ...state, settings: { ...state.settings, chat_bot:action } })
          } 

          toast(response.data.msg, { type: "success" });
        } else {
          toast(response.data.msg, { type: "error" });
        }


      })
  }


  function launchWhatsAppSignup() {
    //connectWA('accessToken')
    // Conversion tracking code
    // fbq && fbq('trackCustom', 'WhatsAppOnboardingStart', {appId: '2244537659052417', feature: 'whatsapp_embedded_signup'});

    // Launch Facebook login
    window.FB.login(function (response) {
      if (response.authResponse) {
        const accessToken = response.authResponse.accessToken;
        connectWA(accessToken)
        //Use this token to call the debug_token API and get the shared WABA's ID
      } else {
        console.log('User cancelled login or did not fully authorize.');
      }
    }, {
      scope: 'whatsapp_business_management',
      extras: {
        featureType: 'whatsapp_business_app_onboarding',
        feature: 'whatsapp_embedded_signup',
        setup: {
        }
      }
    });
  }





  return (
    <>

      <div>
        {state.settings ? (

          <div>
            {bg_loader == true ? <BgLoader /> : (
              <>







                <div className="card card-default mb-4">
                  <div className="card-header"><span className="me-3">WhatsApp Business API</span>{state.help_link ? <a className="btn btn-outline-primary btn-sm" href={state.help_link} target="_blank">Watch integration tutorial <VscLinkExternal /></a> : ''}</div>
                  <div className="card-body">
                    {state.settings.waba_id ? (
                      <div>
                        <div className="row">
                          <div className="col-auto me-auto">
                            <b>Connected to WhatsApp Business Account ID {state.settings.waba_id} {state.settings.is_wa_biz_app = 1 ? ' using WhatsApp Business App' : ''}</b>
                            <p className="mb-0 mt-3">Phone Number: {state.settings.wa_phone}</p>
                            <p>Name: {state.settings.wa_name}</p>
                          </div>
                          <div className="col-auto">
                            <a className="btn btn-outline-primary btn-sm" onClick={() => syncTemplates()}>Sync Templates</a>
                          </div>
                        </div>
                        <div className="alert1 d-flex border-warning bg-warning border-info bg-opacity-25 rounded mb-4">

                          <div className="d-flex flex-stack flex-grow-1 flex-wrap flex-md-nowrap">
                            <div className="mb-3 mb-md-0">

                              <div className="text-muted1 pe-7">
                                Do you want to change or disconnect the WhatsApp API phone number?
                              </div>
                            </div>
                            <a
                              className="btn btn-danger px-6 ms-2 align-self-center text-nowrap"
                              onClick={() => disconnectWA()}
                            >
                              Disconnect
                            </a>
                          </div>
                        </div>
                        <UiToggle
                          id="wa_bot"
                          loading={loader['chat_bot']}
                          name="chat_bot"
                          title="Enable WhatsApp AI Assistant"
                          checked={state.settings.chat_bot == 1 ? true : false}
                          onChange={() => saveSetting('chat_bot', state.settings.chat_bot)}
                        />
                      </div>
                    )
                      :
                      <>
                        <p>Log in with Facebook to register and create your WhatsApp Business Account, add the sender you want to use, and connect with Practive as your Business Solution Provider.</p>
                        <button type="button" onClick={() => launchWhatsAppSignup()} className="btn btn-primary btn-lg" style={{ backgroundColor: '1877f2' }}>Login with Facebook</button>
                      </>}

                    
                  </div>
                </div>

                <div className="card card-default mb-4">
                  <div className="card-header d-flex justify-content-between"><span className="me-3">Message Templates</span>
                  <div>
                  <UiButton onClick={() => templateModal('new')} className="btn btn-outline-primary btn-sm" title="New" icon="add"></UiButton>
                  </div>
                  </div>
                  <div className="card-body">
                    <DataTable
                      columns={columns}
                      data={state.templates || []}
                      noDataComponent={<TableZero title="Templates" />}
                    />

                  </div>
                </div>
              </>
            )}
          </div>
        ) : <BgLoader />
        }
      </div >
    </>
  );
}


